import { Location } from '@angular/common';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  req = req.clone({
    withCredentials: true,
  });

  if (!req.urlWithParams.includes('tenantId')) {
    const location = inject(Location);
    const tenantId = location.path().split('/')[1];

    if (tenantId) {
      req = req.clone({
        setParams: {
          tenantId: tenantId,
        },
      });
    }
  }

  return next(req);
}
